import axiosInstance from "./api_helper";

const inventoryService = {
    findAll: async () => {
        return axiosInstance.get('/api/inventories');
    },
    closeInventory: async (id) => {
        return axiosInstance.post(`/api/inventories/${id}/close`);
    },
    addInventory: async (inventory) => {
        return axiosInstance.post(`/api/inventories`, JSON.stringify(inventory));
    },
    updateInventory: async (payload) => {
        return axiosInstance.put(`/api/inventories/${payload.id}`, JSON.stringify(payload.data));
    },

};
export default inventoryService;
